import httpRequest from "@/utils/api";
import type { DetectionSummary } from "@/types/topic/topicDetector";

enum API {
    detect = "/speaking/topic-detector/detect",
    crawl = "/speaking/topic-detector/crawl",
    import = "/speaking/topic-detector/import"
}

interface RawQuestion {
    oralQuestionId: string | number;
    oralQuestion: string;
    oralPart: number;
}

interface RawTopic {
    oralTopicId: string;
    oralTopicName: string;
    part: number;
    questionList: RawQuestion[];
    category_id?: string;
    order_id?: number;
}

interface CrawlResponse {
    0?: RawTopic[];
    1?: RawTopic[];
}

interface ImportResult {
    topics: number;
    questions: number;
    changed_topic_ids: number[];
    changed_question_ids: number[];
}

interface ImportStatusResult {
    in_progress: boolean;
    inProgress?: boolean;
}

export const detectTopicsAPI = () => {
    return httpRequest.get<DetectionSummary>({
        url: API.detect,
    });
};

export const crawlTopicsAPI = () => {
    return httpRequest.post<CrawlResponse>({
        url: API.crawl,
    });
};

export const importTopicsAPI = () => {
    return httpRequest.post<ImportResult>({
        url: API.import,
    });
};

export const importStatusAPI = () => {
    return httpRequest.get<ImportStatusResult>({
        url: `${API.import}/status`,
    });
}; 